import React from 'react';

import {
  getManagedLoanLead,
  ManagedLoanLeadDetail,
} from '../../services/api/managed-leads/managedLeads';
import {
  ManagedLeadDetailDatum,
  ManagedLeadDetailSection,
} from './components/ManagedLeadDetailSection';
import ManagedProductLeadDetailPage from './components/ManagedProductLeadDetailPage';
import { formatAdvancementDatum } from './managedLeadAdvancementData';
import {
  formatManagedLeadCurrency,
  formatManagedLeadField,
  getManagedLeadFieldValue,
} from './managedLeadFormatting';

const ManagedLoanDetailPage = () => (
  <ManagedProductLeadDetailPage<ManagedLoanLeadDetail>
    product="prestiti"
    productName="Prestiti"
    loadingMessage="Caricamento dettaglio prestito…"
    getLead={getManagedLoanLead}
    renderProductSections={(detail, requestValuesAction) => (
      <>
        <ManagedLeadDetailSection title="Informazioni personali">
          <ManagedLeadDetailDatum
            label="Contratto di lavoro"
            value={formatManagedLeadField(detail.fields.employmentContract)}
          />
          <ManagedLeadDetailDatum
            label="Finanziamenti precedenti"
            value={formatManagedLeadField(detail.fields.previousFinancing)}
          />
          <ManagedLeadDetailDatum
            label="Segnalazioni CRIF"
            value={formatManagedLeadField(detail.fields.latePayments)}
          />
          {detail.fields.companySeniority.state !== 'not_applicable' && (
            <ManagedLeadDetailDatum
              label="Anzianità nell'azienda attuale"
              value={formatManagedLeadField(detail.fields.companySeniority)}
            />
          )}
        </ManagedLeadDetailSection>

        <ManagedLeadDetailSection
          title="Valori prestito"
          action={requestValuesAction}
        >
          <ManagedLeadDetailDatum
            label="Importo richiesto"
            value={formatManagedLeadCurrency(
              getManagedLeadFieldValue(detail.fields.amount)
            )}
          />
          <ManagedLeadDetailDatum
            label="Reddito mensile"
            value={formatManagedLeadCurrency(
              getManagedLeadFieldValue(detail.fields.income)
            )}
          />
          <ManagedLeadDetailDatum
            label="Finalità"
            value={formatManagedLeadField(detail.fields.purpose)}
          />
          <ManagedLeadDetailDatum
            label="Data liquidazione"
            value={formatAdvancementDatum(
              detail.advancementData,
              'liquidationDate',
              'date'
            )}
          />
        </ManagedLeadDetailSection>
      </>
    )}
  />
);

export default ManagedLoanDetailPage;
